import { useSearchParams } from '@/hooks/useNavigate';

interface BrandColorSource {
  background_color?: string;
  text_color?: string;
}

/**
 * Resolves the apply-flow brand colours: a `background_color` / `text_color`
 * query-param override wins, then the API details, then a neutral fallback.
 * Shared by ApplyJob and ClientLocations so both resolve colours identically.
 */
export function useBrandColors(details?: BrandColorSource) {
  const [searchParams] = useSearchParams();

  const backgroundColor =
    searchParams.get('background_color') ||
    details?.background_color ||
    'inherit';
  const textColor =
    searchParams.get('text_color') || details?.text_color || '#ffffff';

  return { backgroundColor, textColor };
}
